module.exports = __webpack_public_path__ + "static/media/sample.ba16d2c9.jpeg";